/* eslint-disable jsx-a11y/anchor-is-valid */
import { Checkbox, Label, TextInput } from "flowbite-react";
import { useState, type FC } from "react";
import { HiOutlineChevronDown, HiOutlineUserAdd } from "react-icons/hi";

export interface DropdownListProp {}

export const DropdownList: FC<DropdownListProp> = (props) => {
  const [show, setShow] = useState(false);

  return (
    <div>
      <div className="w-full">
        <Label htmlFor="contact-persons" value={"Contact"} />
        <form>
          <div className="relative w-full">
            <div>
              <TextInput
                readOnly
                className="w-full"
                value={"2 selected"}
                rightIcon={HiOutlineChevronDown}
                size={50}
                id="contact-persons"
                name="contact-persons"
                type="text"
                color={"white"}
                onClick={() => setShow(!show)}
              />
            </div>
          </div>
        </form>
      </div>
      {show && (
        <div className="absolute w-64 top-18 shadow-sm border border-gray-300 bg-white dark:bg-slate-800 dark:text-white dark:border-slate-600 rounded-lg z-50 mb-8 mt-1">
          <div className="overflow-y-scroll h-48">
            <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 hover:cursor-pointer rounded-tl-lg">
              <Checkbox
                className="text-lgb-primary dark:text-lgb-primary-lighten"
                id="accept"
                defaultChecked
              />
              <Label htmlFor="accept" className="w-full hover:cursor-pointer">
                <span>
                  Henrik Løft
                  <br />
                  <span className="opacity-60">97486548</span>
                </span>
              </Label>
            </div>
            <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 hover:cursor-pointer">
              <Checkbox
                className="text-lgb-primary dark:text-lgb-primary-lighten"
                id="promotion"
              />
              <Label
                htmlFor="promotion"
                className="w-full hover:cursor-pointer"
              >
                <span>
                  Andreas Fjell
                  <br />
                  <span className="opacity-60">97486548</span>
                </span>
              </Label>
            </div>
            <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 hover:cursor-pointer">
              <Checkbox
                className="text-lgb-primary dark:text-lgb-primary-lighten"
                id="age"
              />
              <Label htmlFor="age" className="w-full hover:cursor-pointer">
                <span>
                  Kristian Haug
                  <br />
                  <span className="opacity-60">97486548</span>
                </span>
              </Label>
            </div>
            <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 hover:cursor-pointer">
              <Checkbox
                className="text-lgb-primary dark:text-lgb-primary-lighten"
                id="age"
              />
              <Label htmlFor="age" className="w-full hover:cursor-pointer">
                <span>
                  Håvard Stein
                  <br />
                  <span className="opacity-60">97486548</span>
                </span>
              </Label>
            </div>
            <div className="flex items-center gap-2 px-2 py-2 hover:bg-gray-100 dark:hover:bg-slate-600 hover:cursor-pointer">
              <Checkbox
                className="text-lgb-primary dark:text-lgb-primary-lighten"
                id="age"
              />
              <Label htmlFor="age" className="w-full hover:cursor-pointer">
                <span>
                  Oddvar Palle
                  <br />
                  <span className="opacity-60">97486548</span>
                </span>
              </Label>
            </div>
          </div>
          <div className="w-full flex justify-center py-2 border-t border-t-gray-300 bg-white dark:bg-slate-800 dark:text-white dark:border-slate-600 hover:cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-600">
            <div className="flex items-center">
              <HiOutlineUserAdd className="text-lgb-main-green dark:text-lgb-main-green-lighten mr-2 h-5 w-5" />
              Add contact person
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
